<template>
    <div class="container-trait">
        <div class="traTitle">
            <h3>{{ detailInfo.efoOntologyTrait }}</h3>
        </div>
        <div class="title">Trait information</div>
        <table class="table table-bordered table-hover">
            <tbody>
                <tr>
                    <td>Trait Label</td>
                    <td>
                        <a
                            :href="detailInfo.efoCode?.indexOf('EFO:') >= 0 ? 'http://www.ebi.ac.uk/efo/' + detailInfo.efoCode?.replaceAll(':', '_') : 'http://purl.obolibrary.org/obo/' + detailInfo.efoCode?.replaceAll(':', '_')">{{
                detailInfo.efoOntologyTrait }}</a>
                    </td>
                </tr>
                <tr>
                    <td>Ontology ID</td>
                    <td>
                        <a
                            :href="detailInfo.efoCode?.indexOf('EFO:') >= 0 ? 'http://www.ebi.ac.uk/efo/' + detailInfo.efoCode?.replaceAll(':', '_') : 'http://purl.obolibrary.org/obo/' + detailInfo.efoCode?.replaceAll(':', '_')">{{
                detailInfo.efoCode }}</a>
                    </td>
                </tr>
                <tr>
                    <td>Description</td>
                    <td>{{ detailInfo.description != 'skip' ? detailInfo.description : '' }}</td>
                </tr>
                <tr>
                    <td>Trait Type</td>
                    <td>{{ detailInfo.traitType }}</td>
                </tr>
                <tr>
                    <td>Synonyms</td>
                    <td>{{ detailInfo.synonym }}</td>
                </tr>
                <tr>
                    <td>More Trait Information</td>
                    <td>
                        <a
                            :href="detailInfo.efoCode?.indexOf('EFO:') >= 0 ? 'http://www.ebi.ac.uk/efo/' + detailInfo.efoCode?.replaceAll(':', '_') : 'http://purl.obolibrary.org/obo/' + detailInfo.efoCode?.replaceAll(':', '_')">EFO
                            Trait</a>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="tableT">All GWAS Summary Statistics associated with the trait</div>

        <div>
            <trait_summary :trait-id="traitId" />
        </div>

        <br />
        <br />
        <p style="text-align: center; font-size: 22px;"><b>Manhattan Plot (Users can obtain more information about the
                associations by hovering their mouse over the dots representing each gene)</b></p>
        <br />

        <div class="echarts-tool">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="Enable Information" size="medium">
                    <span slot="label" style="font-size: 16px;">Enable Information</span>
                    <div class="tool-item">
                        <div>
                            <el-switch v-model="showTooltip" @change="handleShowLegend" />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="C">
                    <span slot="label" style="font-size: 16px;">Chromosome</span>
                    <el-select v-model="formInline.chr" placeholder="Choose one chr">
                        <el-option label="All" value="">All</el-option>
                        <el-option :label="'chr' + index" :value="index" v-for="index in chrList"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSearch">Search</el-button>
                </el-form-item>
            </el-form>

        </div>

        <p style="font-size: 20px; text-align: center; font-weight: bold; color: red;">Customize Manhattan plots by selecting your preferred methods and zooming in on individual chromosomes for clearer analysis.</p>
        <div class="echarts-scatter">
            <div style="width: 100%; height: 100%" ref="scatter"></div>
        </div>

        <div class="tableT">Genes associated with the trait</div>
        <div>
            <trait_gene :trait-id="traitId" />
        </div>

    </div>
</template>

<script>
import { traitassoc, traitpub } from "@/mock";
import Trait_summary from "@/views/trait/trait_summary";
import Trait_gene from "@/views/trait/trait_gene";
import Trait_snp from "@/views/trait/trait_snp";
import _ from "lodash";

const chrMap = {
    1: 248849517,
    2: 242078722,
    3: 198148238,
    4: 188147743,
    5: 181272307,
    6: 170572870,
    7: 159154430,
    8: 145066685,
    9: 138124624,
    10: 133569835,
    11: 134319564,
    12: 133235877,
    13: 114337626,
    14: 106368436,
    15: 101806887,
    16: 90095932,
    17: 83095122,
    18: 80247514,
    19: 58573575,
    20: 64304820,
    21: 46665124,
    22: 50783667,
};

const chrPositionMap = {
    1: [817371, 248849517],
    2: [105004, 242078722],
    3: [1092658, 198148238],
    4: [124501, 188147743],
    5: [196868, 181272307],
    6: [221828, 170572870],
    7: [549197, 159154430],
    8: [406428, 145066685],
    9: [120837, 138124624],
    10: [274190, 133569835],
    11: [205935, 134319564],
    12: [220621, 133235877],
    13: [19173772, 114337626],
    14: [19773504, 106368436],
    15: [20531856, 101806887],
    16: [17659, 90095932],
    17: [212389, 83095122],
    18: [334837, 80247514],
    19: [463346, 58573575],
    20: [142590, 64304820],
    21: [10521553, 46665124],
    22: [16590751, 50783667],
    X: [624344, 155239841],
    Y: [2841602, 20593154],
}

const zoomOut = 500000;
let xAxisLabel = {};

const chrTotal = Object.values(chrMap).reduce(function (pre, cur, i) {
    xAxisLabel[i + 1] = pre + cur;
    return pre + cur;
}, 0);

function getDotPosX(dot) {
    let posX = xAxisLabel[dot.chr - 1] || 0;
    posX += dot.start;

    return Math.floor(posX / zoomOut);
}

let _data = [];
let echarts = null;


export default {
    name: "trait",
    components: {
        Trait_gene,
        Trait_summary,
    },
    data() {
        echarts = null;
        return {
            traitId: this.$route.params.id,
            traitassoc: traitassoc,
            traitpub: traitpub,
            showTooltip: true,
            detailInfo: {
                name: "",
                ontologyId: "",
                synonyms: "",
                type: "",
                description: "",
            },
            formInline: {

            },
            chrList: []
        };
    },

    created() {
        this.getDetail();
    },

    mounted() {
        this.getEchartsData();
    },

    methods: {
        handleShowLegend() {
            if (this.formInline.chr) {
                this.draw_chr();
            } else {
                this.draw();
            }
        },

        async getEchartsData() {
            let q = ''
            if (this.formInline.chr) {
                q = 'chr=' + this.formInline.chr
            }
            let res = await this.$ajax.get(`trait/${this.traitId}/manhattan/?${q}`);
            _data = res.data

            if (this.formInline.chr) {
                this.draw_chr()
            } else {
                this.draw();
            }
        },

        onSearch() {
            this.getEchartsData()
        },

        draw() {
            if (!echarts) {
                echarts = this.$echarts.init(this.$refs.scatter);
            }
            let dataTypeMap = {
                // Variant: [],
            };

            let chrList = []
            _data.forEach((v) => {
                chrList.push(v.chr);
                v.method = v.method.slice(0, 1).toUpperCase() + v.method.slice(1);
                if (!dataTypeMap[v.method]) {
                    dataTypeMap[v.method] = [];
                }
                dataTypeMap[v.method].push({
                    name: v.method,
                    value: [getDotPosX(v), v.y],
                    _extend: v,
                });
            });

            if (this.chrList.length == 0) {
                this.chrList = _.uniq(chrList).map(it => parseInt(it)).sort((a, b) => a - b)
            }

            const dataTypeMapKeyArr = Object.keys(dataTypeMap);
            const data = dataTypeMapKeyArr.map((key) => {
                return {
                    name: key,
                    type: "scatter",
                    // symbol: (key === "Gene" && "rect") || null,
                    // 圆的大小
                    symbolSize: 5,
                    // 圆的标签
                    label: {
                        show: this.showTooltip,
                        position: "top",
                        formatter: function (params) {
                            const data = params.data._extend;
                            return data.name;
                        },
                    },
                    data: dataTypeMap[key],
                };
            });

            const option = {
                color: [
                    "#5470c6",
                    "#91cc75",
                    "#fac858",
                    "#ee6666",
                    "#73c0de",
                    "#3ba272",
                    "#fc8452",
                    "#9a60b4",
                    "#ea7ccc",
                    "#4962FC",
                    "#4B7CF3",
                    "#dd3ee5",
                    "#12e78c",
                    "#fe8104",
                    "#01C2F9",
                    "#F4CB29",
                    "#FD9E06",
                ],
                grid: {
                    top: 100,
                    right: 50,
                },
                legend: {
                    show: true,
                    // data: dataTypeMapKeyArr,
                    data: Object.keys(dataTypeMap),
                    top: 5,
                    left: "10%",
                    textStyle: {
                        fontSize: 20,
                    },
                },
                tooltip: {
                    show: true,
                    formatter: function (params) {
                        // params.value[0]  x轴 数据
                        // params.value[1]  y轴 数据

                        const results = [];

                        const _extend = params.data._extend;
                        if (_extend.description) {
                            const lines = _extend.description.split("\n");
                            lines.forEach((it) => {
                                const splits = it.split(";");
                                splits.forEach((split) => {
                                    results.push(split);
                                });
                            });
                        }

                        return results.join("<br />");
                    },
                },
                xAxis: {
                    show: true,
                    name: "Genomic Position(number denotes chromosome)",
                    nameGap: 25,
                    nameLocation: "center",
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    minInterval: 1,
                    // maxInterval: 1,
                    max: Math.floor((chrTotal + zoomOut) / zoomOut),
                    min: 1,
                    interval: 1,
                    axisLabel: {
                        show: true,
                        formatter: (value) => {
                            let i = Object.values(xAxisLabel)
                                .map((v, _i) => v - chrMap[_i + 1] / 2)
                                .map((v) => Math.floor(v / zoomOut))
                                .indexOf(value);
                            return i + 1 || "";
                        },
                    },
                    splitNumber: 0,
                    nameTextStyle: {
                        fontSize: 15,
                    },
                },
                yAxis: {
                    show: true,
                    name: "-log10 P-value",
                    nameGap: 30,
                    max: 50,
                    nameLocation: "center",
                    nameTextStyle: {
                        fontSize: 15,
                    },
                },
                series: data,
            };

            echarts.setOption(option, true);
        },

        async getDetail() {
            let res = await this.$ajax.get(`trait/${this.traitId}`);
            this.detailInfo = res.data;
        },

        draw_chr() {
            if (!echarts) {
                echarts = this.$echarts.init(this.$refs.scatter);
            }
            let dataTypeMap = {
                // Variant: [],
            };

            let chrList = []
            _data.forEach((v) => {
                chrList.push(v.chr);
                v.method = v.method.slice(0, 1).toUpperCase() + v.method.slice(1);
                if (!dataTypeMap[v.method]) {
                    dataTypeMap[v.method] = [];
                }
                dataTypeMap[v.method].push({
                    name: v.method,
                    value: [v.start, v.y],
                    _extend: v,
                });
            });

            if (this.chrList.length == 0) {
                this.chrList = _.uniq(chrList).map(it => parseInt(it)).sort((a, b) => a - b)
            }

            const dataTypeMapKeyArr = Object.keys(dataTypeMap);
            const data = dataTypeMapKeyArr.map((key) => {
                return {
                    name: key,
                    type: "scatter",
                    // symbol: (key === "Gene" && "rect") || null,
                    // 圆的大小
                    symbolSize: 5,
                    // 圆的标签
                    label: {
                        show: this.showTooltip,
                        position: "top",
                        formatter: function (params) {
                            const data = params.data._extend;
                            return data.name;
                        },
                    },
                    data: dataTypeMap[key],
                };
            });

            const option = {
                color: [
                    "#5470c6",
                    "#91cc75",
                    "#fac858",
                    "#ee6666",
                    "#73c0de",
                    "#3ba272",
                    "#fc8452",
                    "#9a60b4",
                    "#ea7ccc",
                    "#4962FC",
                    "#4B7CF3",
                    "#dd3ee5",
                    "#12e78c",
                    "#fe8104",
                    "#01C2F9",
                    "#F4CB29",
                    "#FD9E06",
                ],
                grid: {
                    top: 100,
                    right: 50,
                },
                legend: {
                    show: true,
                    // data: dataTypeMapKeyArr,
                    data: Object.keys(dataTypeMap),
                    top: 5,
                    left: "10%",
                    textStyle: {
                        fontSize: 20,
                    },
                },
                tooltip: {
                    show: true,
                    formatter: function (params) {
                        // params.value[0]  x轴 数据
                        // params.value[1]  y轴 数据

                        const results = [];

                        const _extend = params.data._extend;
                        if (_extend.description) {
                            const lines = _extend.description.split("\n");
                            lines.forEach((it) => {
                                const splits = it.split(";");
                                splits.forEach((split) => {
                                    results.push(split);
                                });
                            });
                        }

                        return results.join("<br />");
                    },
                },
                xAxis: {
                    show: true,
                    name: "Genomic Position(number denotes chromosome)",
                    nameGap: 25,
                    nameLocation: "center",
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    // minInterval: 1,
                    // maxInterval: 1,
                    max: () => {
                        return chrPositionMap[this.formInline.chr][1]
                    },
                    min: () => {
                        // if (this.formInline.chr > 1) {
                        //     const start = chrMap[this.formInline.chr-1]
                        //     debugger
                        //     return start
                        // }
                        return 1
                    },
                    // interval: 1,
                    // splitNumber: 0,
                    // min: 3000,
                    nameTextStyle: {
                        fontSize: 15,
                    },
                },
                yAxis: {
                    show: true,
                    name: "-log10 P-value",
                    nameGap: 30,
                    max: 50,
                    nameLocation: "center",
                    nameTextStyle: {
                        fontSize: 15,
                    },
                },
                series: data,
            };

            echarts.setOption(option, true);
        },

        async getDetail() {
            let res = await this.$ajax.get(`trait/${this.traitId}`);
            this.detailInfo = res.data;
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/common/style/traDetail";

.search-input {
    display: inline-block;
    width: 200px;
}

.traTitle {
    h3 {
        color: #176b6e;
        padding: 0 15px 0 0;
        display: inline-block;
    }

    a {
        border-radius: 50px;
        display: inline-block;
        margin-top: 20px;
        margin-bottom: 10px;
        padding: 0 20px;
        line-height: 1.3;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
        background-color: #9b5057;
        text-decoration: underline;
    }
}

.container-trait {
    padding: 0 45px;
}

.table {
    tr {
        td:first-child {
            color: #176b6e;
            width: 180px;
        }

        td {
            line-height: 30px !important;
            font-size: 16px;
            word-break: break-all;
            word-wrap: break-word;
        }
    }
}

.title {
    margin-bottom: 55px;
    font-size: 24px;
    font-weight: bold;
}

.echarts-scatter {
    width: 100%;
    height: 800px;
}

.echarts-tool {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0 15px;

    .tool-item {
        display: flex;
        align-items: center;
        margin-right: 15px;
    }

    .label {
        font-weight: normal;
        font-size: 14px;
        color: #333333;
        padding: 0;
        margin: 0 5px 0 0;
    }
}
</style>
